import { ENV_COUNTRY, HOTLINE, HOTLINE_TEXT } from 'sysconfig';

export const ENUM_SCOPE = {
  PHARMACY: 'PHARMACY',
  DRUGSTORE: 'DRUGSTORE',
  ANIMAL_PHARMACY: 'ANIMAL_PHARMACY',
  WHOLESALE_PHARMACY: 'WHOLESALE_PHARMACY',
  DENTISTRY: 'DENTISTRY',
  HOSPITAL: 'HOSPITAL',
  ANIMAL_CLINIC: 'ANIMAL_CLINIC',
  CLINIC: 'CLINIC',
  NURSE_CLINIC: 'NURSE_CLINIC',
  BEAUTY_SALON: 'BEAUTY_SALON',
  HEALTH_CENTER: 'HEALTH_CENTER',
  PHARMA_COMPANY: 'PHARMA_COMPANY',
  NEW_CUSTOMER: 'NEW_CUSTOMER',
};

export const ENUM_SCOPE_LABEL = {
  [ENUM_SCOPE.DRUGSTORE]: 'drugstore',
  [ENUM_SCOPE.PHARMACY]: 'pharmacy',
  [ENUM_SCOPE.CLINIC]: 'clinic',
  [ENUM_SCOPE.HOSPITAL]: 'hospital',
  [ENUM_SCOPE.PHARMA_COMPANY]: 'drug_company',
  [ENUM_SCOPE.DENTISTRY]: 'dentist',
  [ENUM_SCOPE.BEAUTY_SALON]: 'beauty_salon',
  [ENUM_SCOPE.HEALTH_CENTER]: 'health_center',
  [ENUM_SCOPE.ANIMAL_PHARMACY]: 'animal_center',
  [ENUM_SCOPE.WHOLESALE_PHARMACY]: 'wholesale_center',
  [ENUM_SCOPE.ANIMAL_CLINIC]: 'animal_clinic',
  [ENUM_SCOPE.NURSE_CLINIC]: 'nurse_clinic',
  [ENUM_SCOPE.NEW_CUSTOMER]: 'new_customer',
};

export const PAYMENT_METHOD = {
  COD: 'PAYMENT_METHOD_NORMAL',
  TRANSFER: 'PAYMENT_METHOD_BANK',
  CREDIT: 'PAYMENT_METHOD_CREDIT',
  QR_BEAM: 'PAYMENT_METHOD_QR_BEAM',
};

export const DEFAULT_BANK_TRANSFER_WAITING_HOURS = 72;
export const DEFAULT_NON_BANK_WAITING_HOURS = 72;

export const PAYMENT_METHOD_NEED_WAITING = [PAYMENT_METHOD.QR_BEAM];

export const BEAM_CHECK_IN_STATUS = {
  PAID: 'PAID',
  UNPAID: 'UNPAID',
  CANCELLED: 'CANCELLED',
};

export const ENUM_TYPE = {};

export const RIBBON_STATUS = {
  UP: 'up',
  DOWN: 'down',
};

export const PROMO_TYPE = {
  DISCOUNT: 'DISCOUNT',
  COMBO: 'COMBO',
  GIFT: 'GIFT',
  VOUCHERCODE: 'VOUCHERCODE',
  FREESHIP: 'FREESHIP',
  PERCENTAGE: 'PERCENTAGE',
  ABSOLUTE: 'ABSOLUTE',
  POINT: 'POINT',
};

// deprecated 22Feb2023 - Dinh Tran
// export const PROMOTION_STATUS = {
//   WAITING: 'WAITING',
//   ACTIVE: 'ACTIVE',
//   FULL: 'FULL',
//   EXPIRED: 'EXPIRED',
//   DELETED: 'DELETED',
// };

// export const PROMOTION_SCOPE = {
//   GLOBAL: 'GLOBAL',
//   SELLER: 'SELLER',
//   CATEGORY: 'CATEGORY',
//   PRODUCT: 'PRODUCT',
//   SKU: 'SKU',
// };

// export const PROMO_RULE_FIELD_TYPE = {
//   MIN_QUANTITY: 'MIN_QUANTITY',
//   MIN_ORDER_VALUE: 'MIN_ORDER_VALUE',
// };

// export const PROMO_RULE_TYPE = {
//   VALUE: 'VALUE',
//   PERCENT: 'PERCENT',
//   GIFT: 'GIFT',
//   PRODUCT: 'PRODUCT',
//   ABSOLUTE: 'ABSOLUTE',
// };

export const PROMO_REWARD_TYPE = {
  PERCENTAGE: 'PERCENTAGE',
  GIFT: 'GIFT',
  POINT: 'POINT',
  ABSOLUTE: 'ABSOLUTE',
};

export const HTTP_STATUS = {
  Ok: 'OK',
  Error: 'ERROR',
  Invalid: 'INVALID',
  NotFound: 'NOT_FOUND',
  Forbidden: 'FORBIDDEN',
  Existed: 'EXISTED',
  Unauthorized: 'UNAUTHORIZED',
};

// export const PRODUCT_TYPE = {
//   CAN_INVOICE: 'can invoice',
// };

export const DEFAULT_PAGINATION = {
  OFFSET: 0,
  LIMIT: 20,
  TOTAL: 0,
};

export const ALIGN = {
  LEFT: 'left',
  RIGHT: 'right',
  CENTER: 'center',
};

export const LIST_REASONS = [
  {
    code: 'SAI_SAN_PHAM',
    name: 'Sai sản phẩm',
  },
  {
    code: 'DONG_THIEU_HANG',
    name: 'Đóng thiếu hàng',
  },
  {
    code: 'DONG_DU_HANG',
    name: 'Đóng dư hàng',
  },
  {
    code: 'CAN_NGAY',
    name: 'Cận ngày',
  },
  {
    code: 'SAN_PHAM_HU_BE',
    name: 'Sản phẩm hư bể',
  },
  {
    code: 'CHENH_LECH_CHUYEN_KHOAN',
    name: 'Chênh lệch chuyển khoản',
  },
  {
    code: 'KHACH_DAT_SAI',
    name: 'Khách đặt sai',
  },
  {
    code: 'MAT_HANG',
    name: 'Mất hàng',
  },
  {
    code: 'SAI_HOA_DON',
    name: 'Sai hóa đơn',
  },
  {
    code: 'GIAO_LON_THUNG_HANG',
    name: 'Giao lộn thùng hàng',
  },
  {
    code: 'GIAO_HANG_TRE',
    name: 'Giao hàng trễ',
  },
  {
    code: 'HUY_DON',
    name: 'Hủy đơn',
  },
  {
    code: 'TRA_HANG_VE',
    name: 'Trả hàng về',
  },
  {
    code: 'CHAT_LUONG_SAN_PHAM',
    name: 'Chất lượng sản phẩm',
  },
  {
    code: 'DONG_SAI_SO_LUONG',
    name: 'Đóng sai số lượng',
  },
  {
    code: 'HEN_GIAO_HANG',
    name: 'Hẹn giao hàng',
  },
  {
    code: 'HOA_DON_DO',
    name: 'Hóa đơn đỏ',
  },
  {
    code: 'HOI_GIAO_HANG',
    name: 'Hối giao hàng',
  },
  {
    code: 'KHACH_TU_Y_HUY_DON',
    name: 'Khách tự ý hủy đơn',
  },
  {
    code: 'KHONG_LIEN_LAC_DUOC_KHACH',
    name: 'Không liên lạc được khách',
  },
  {
    code: 'SAI_DIA_CHI',
    name: 'Sai địa chỉ',
  },
  {
    code: 'THAY_DOI_DIA_CHI',
    name: 'Thay đổi địa chỉ',
  },
  {
    code: 'THAY_DOI_HINH_THUC_THANH_TOAN',
    name: 'Thay đổi hình thức thanh toán',
  },
  {
    code: 'THAY_DOI_SO_LUONG',
    name: 'Thay đổi số lượng',
  },
  {
    code: 'TINH_TRANG_DON_HANG',
    name: 'Tình trạng đơn hàng',
  },
  {
    code: 'GHI_CHU_DON_HANG',
    name: 'Ghi chú đơn hàng',
  },
  {
    code: 'THAC_MAC_SAN_PHAM',
    name: 'Thắc mắc sản phẩm',
  },
  {
    code: 'THAC_MAC_DICH_VU',
    name: 'Thắc mắc dịch vụ',
  },
  {
    code: 'THAC_MAC_THANH_TOAN',
    name: 'Thắc mắc thanh toán',
  },
  {
    code: 'LOI_KI_THUAT',
    name: 'Lỗi kĩ thuật',
  },
  {
    code: 'VAN_DE_KHAC',
    name: 'Vấn đề khác',
  },
];

export const LIST_REASONS_MAP = LIST_REASONS.reduce((map, item) => {
  // eslint-disable-next-line no-param-reassign
  map[item.code] = item;
  return map;
}, {});

// export const FEEDBACK_REASON = LIST_REASONS_MAP;
// {
//   DONG_THIEU_HANG: {
//     code: 'DONG_THIEU_HANG',
//     name: 'Đóng thiếu hàng',
//   },
//   DONG_DU_HANG: {
//     code: 'DONG_DU_HANG',
//     name: 'Đóng dư hàng',
//   },
// };

export const ENUM_ORDER_STATUS = {
  ALL: 'ALL',
  WAIT_TO_CONFIRM: 'WAIT_TO_CONFIRM',
  CONFIRMED: 'CONFIRMED',
  PROCESSING: 'PROCESSING',
  DELIVERING: 'DELIVERING',
  TRANSPORTING: 'TRANSPORTING',
  DELIVERED: 'DELIVERED',
  CANCEL: 'CANCEL',
  COMPLETED: 'COMPLETED',
  WAIT_TO_DELIVER: 'WAIT_TO_DELIVER',
};
export const ENUM_GARMINICATION = {
  ALL: 'ALL',
  UPCOMING: 'UPCOMING',
  IN_PROGRESS: 'IN_PROGRESS',
  FINISHED: 'FINISHED',
  COMPLETED: 'EXPIRED',
};
export const GARMINICATION_STATUS = [
  {
    value: 'ALL',
    label: 'Tất cả',
    color: '#fff',
    background: '#fff',
  },
  {
    value: 'PROCESSING',
    label: 'Đang diễn ra',
    color: '#D4323B',
    background: '#FFEAEA',
  },
  {
    value: 'UPCOMING',
    label: 'Sắp diễn ra',
    color: '#A87E00',
    background: '#FCF4DE',
  },
  {
    value: 'EXPIRED',
    label: 'Đã kết thúc',
    color: '#636363',
    background: '#E9E9E9',
  },
];
export const ENUM_ORDER_STATUS_LABEL = {
  [ENUM_ORDER_STATUS.WAIT_TO_CONFIRM]: 'Chờ xác nhận',
  [ENUM_ORDER_STATUS.CONFIRMED]: 'Đã xác nhận',
  [ENUM_ORDER_STATUS.PROCESSING]: 'Đang xử lý',
  [ENUM_ORDER_STATUS.DELIVERING]: 'Đang vận chuyển',
  [ENUM_ORDER_STATUS.TRANSPORTING]: 'Đang trung chuyển',
  [ENUM_ORDER_STATUS.WAIT_TO_DELIVER]: 'Chờ vận chuyển',
  [ENUM_ORDER_STATUS.DELIVERED]: 'Đã giao',
  [ENUM_ORDER_STATUS.CANCEL]: 'Đã hủy',
  [ENUM_ORDER_STATUS.COMPLETED]: 'Đã hoàn tất',
};

export const ENUM_ORDER_STATUS_COLOR = {
  [ENUM_ORDER_STATUS.WAIT_TO_CONFIRM]: 'btn--default',
  [ENUM_ORDER_STATUS.CONFIRMED]: 'btn--default',
  [ENUM_ORDER_STATUS.PROCESSING]: 'btn--default',
  [ENUM_ORDER_STATUS.WAIT_TO_DELIVER]: 'btn--default',
  [ENUM_ORDER_STATUS.DELIVERING]: 'btn--delivery',
  [ENUM_ORDER_STATUS.TRANSPORTING]: 'btn--delivery',
  [ENUM_ORDER_STATUS.DELIVERED]: 'btn--delivered',
  [ENUM_ORDER_STATUS.CANCEL]: 'btn--cancel',
  [ENUM_ORDER_STATUS.COMPLETED]: 'btn--complete',
};

export const ENUM_ORDER_TYPE = {
  NORMAL: 'NORMAL',
  COMBO: 'COMBO',
  DEAL: 'DEAL',
  GIFT: 'GIFT',
  CAMPAIGN: 'CAMPAIGN',
};

export const GROUP_ADDRESS_TYPE = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
};

export const ADDRESS_CHANGE_TYPE = {
  ASSIGNED: 'ASSIGNED',
  PROVINCE_CHANGE: 'PROVINCE_CHANGE',
  DISTRICT_CHANGE: 'DISTRICT_CHANGE',
  WARD_CHANGE: 'WARD_CHANGE',
};

export const LOYALTY_HISTORY_TYPE = {
  INCREMENT: 'INCREMENT',
  DECREMENT: 'DECREMENT',
};

export const REFERRAL_STATUS = {
  NEW: 'NEW',
  APPROVED: 'APPROVED',
  DECLINED: 'DECLINED',
};

export const REFERRAL_STATUS_LABEL = {
  [REFERRAL_STATUS.NEW]: 'enum.REFERRAL_STATUS_LABEL.NEW',
  [REFERRAL_STATUS.APPROVED]: 'enum.REFERRAL_STATUS_LABEL.APPROVED',
  [REFERRAL_STATUS.DECLINED]: 'enum.REFERRAL_STATUS_LABEL.DECLINED',
};

// export const LOYALTY_HISTORY_TYPE_LABEL = {
//   [LOYALTY_HISTORY_TYPE.INCREMENT]: 'Tích luỹ',
//   [LOYALTY_HISTORY_TYPE.DECREMENT]: 'Đã đổi điểm',
// };

export const FILE_TYPE = {
  PDF: 'application/pdf',
  PNG: 'image/png',
  JPEG: 'image/jpeg',
  DOC: 'application/msword',
  DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
};

export const LOYALTY_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};

export const ENUMS_PAYMENT_METHOD = {
  PAYMENT_METHOD_NORMAL: 'PAYMENT_METHOD_NORMAL',
  PAYMENT_METHOD_BANK: 'PAYMENT_METHOD_BANK',
  PAYMENT_METHOD_CREDIT: 'PAYMENT_METHOD_CREDIT',
};

export const PAYMENT_METHOD_NAME = {
  PAYMENT_METHOD_NORMAL: 'Thanh toán tiền mặt khi nhận hàng',
  PAYMENT_METHOD_BANK: 'Thanh toán chuyển khoản',
  PAYMENT_METHOD_CREDIT: 'Thanh toán hợp đồng',
};
export const PAYMENT_METHOD_NAME_SHORT = {
  PAYMENT_METHOD_NORMAL: 'Tiền mặt',
  PAYMENT_METHOD_BANK: 'Chuyển khoản',
  PAYMENT_METHOD_BANK_1: 'Chuyển khoản',
  PAYMENT_METHOD_CREDIT: 'Hợp đồng',
};
export const ARR_REMOVE_PRODUCT = [
  'NOT_ACTIVE_SKU',
  'SUSPENDED_SKU',
  'STOP_PRODUCING_SKU',
  'OUT_OF_STOCK_SKU',
  'CART_ITEM_INVALID',
  'NOT_AVAILABLE_SKU',
  'NOT_AVAILABLE_SCOPE',
  'NOT_FOUND_SKU',
  'NOT_FOUND_PRICE_SKU',
  'COMBO_INVALID',
  'REQUIRED_CERTIFICATE',
];
export const FLUCTUATED_TYPE = {
  INCREASED: 'INCREASED',
  DECREASED: 'DECREASED',
};

export const SELLER_GROUP = {
  MEDX: 'MEDX',
  DOITAC: 'DOITAC',
  HANGMUAHO: 'HANGMUAHO',
  DUREX: 'DUREX', // hardcode cho DUREX,
  GIFT_ORDER: 'GIFT_ORDER',
};

// export const LEVEL_CODE = {
//   LEVEL_SLIVER: 'LEVEL_SLIVER',
//   LEVEL_SILVER: 'LEVEL_SILVER',
//   LEVEL_GOLD: 'LEVEL_GOLD',
//   LEVEL_PLATINUM: 'LEVEL_PLATINUM',
//   LEVEL_DIAMOND: 'LEVEL_DIAMOND',
// };

export const LEVEL_CUSTOMER = {
  LEVEL_SLIVER: 'bạc',
  LEVEL_SILVER: 'bạc',
  LEVEL_GOLD: 'vàng',
  LEVEL_PLATINUM: 'bạch kim',
  LEVEL_DIAMOND: 'kim cương',
};

// export const ACTIVE_STORE_TAG = 'thuocsi.vn Store';

export { default as EnumsTicket } from './EnumsTicket';

export default {
  ENUM_SCOPE,
  ENUM_TYPE,
  HTTP_STATUS,
  ENUM_ORDER_TYPE,
};

// export const MAX_WEIGHT = 20000;
// export const MAX_VOLUME = 62400000;
// export const COLOR_CUSTOMER = {
//   GREEN: 'GREEN',
//   YELLOW: 'YELLOW',
//   ORANGE: 'ORANGE',
//   RED: 'RED',
//   BLUE: 'BLUE', // VIP
//   PURPLE: 'PURPLE', // VIP - công nợ
// };
export const CUSTOMER_TAG = {
  BAN: 'BAN',
  BLOCK_COD: 'BLOCK_COD',
};
export const TYPE_CUSTOMER_BY_COLOR = {
  LOCKED_CUSTOMER: 'LOCKED_CUSTOMER',
};
export const FLAGSHIP_LABEL = 'enum.FLAGSHIP_LABEL';
export const THUOCSI_LABEL = ENV_COUNTRY === 'vn' ? 'thuocsi.vn Store' : 'Buymed Store';
export const MOBILE_FLAGSHIP_LABEL = 'enum.MOBILE_FLAGSHIP_LABEL';
export const LABEL_GIFT_TAG_PROMOTION = 'Tặng Quà';

export const ENUM_ORDER_STATUS_COLOR_V2 = {
  [ENUM_ORDER_STATUS.WAIT_TO_CONFIRM]: '#788FCA',
  [ENUM_ORDER_STATUS.CONFIRMED]: '#3B438F',
  [ENUM_ORDER_STATUS.PROCESSING]: '#E8AE00',
  [ENUM_ORDER_STATUS.DELIVERING]: '#D4323B',
  [ENUM_ORDER_STATUS.DELIVERED]: '#01A0B5',
  [ENUM_ORDER_STATUS.CANCEL]: '#A2A0A0',
  [ENUM_ORDER_STATUS.COMPLETED]: '#005C29',
  [ENUM_ORDER_STATUS.WAIT_TO_DELIVER]: '#D55D2A',
};

export const ENUM_INVOICE_STATUS = {
  NOT: 'Chưa xuất hoá đơn',
  REQUEST: 'Đã yêu cầu xuất hoá đơn',
  EXPORT: 'Đã xuất hoá đơn',
};

export const ARR_STATUS_WARE_HOUSE = [
  'DRAFT',
  'CONFIRMED',
  'RESERVING',
  'WAIT_TO_PICK',
  'PICKING',
  'WAIT_TO_CHECK',
  'CHECKING',
  'WAIT_TO_PACK',
  'PACKING',
  'WAIT_TO_DELIVERY',
  'DELIVERING',
  'DELIVERED',
  'COMPLETED',
  'RETURN',
  'RETURNING',
  'RETURNED',
  'DAMAGE',
  'LOST',
  'CANCEL',
];

export const MONITORING_COLLECTOR_TYPE = {
  LOGIN: 'LOGIN',
  SKU_DETAIL_VIEW: 'SKU_DETAIL_VIEW',
  ADD_TO_CART: 'ADD_TO_CART',
  REMOVE_FROM_CART: 'REMOVE_FROM_CART',
  SKU_IMPRESSION: 'SKU_IMPRESSION',
};

export const THUOCSI_RECOMMENDATION = {
  SAME_CATEGORY: 'SAME_CATEGORY',
  PURCHASE_TOGETHER: 'PURCHASE_TOGETHER',
  ALL: 'ALL',
};

export const INSIDER_RECOMMENDATION = {
  MOST_VIEWED: 'MOST_VIEWED',
  USER_BASED: 'USER_BASED',
};

// export const ENUM_TRACKING_NAVBAR = {
//   GO_TO_PROMO_CODES_PAGE: 'GO_TO_PROMO_CODES_PAGE',
//   GO_TO_PRODUCTS_PAGE: 'GO_TO_PRODUCTS_PAGE',
//   GO_TO_QUICKORDER_PAGE: 'GO_TO_QUICKORDER_PAGE',
//   GO_TO_CAMPAIGN_PAGE: 'GO_TO_CAMPAIGN_PAGE',
//   GO_TO_SELLER_PAGE: ' GO_TO_SELLER_PAGE',
//   GO_TO_EVENTS_PAGE: ' GO_TO_EVENTS_PAGE',
// };

export const ENUM_TRACKING_ACTION = Object.freeze({
  // page promo-codes
  PROMO_GO_TO_QUICK_ORDER: 'CLICK_QUICK_ORDER_LINK_ON_PROMO_CODES_PAGE',
  PROMO_GO_TO_PRODUCTS: 'CLICK_PRODUCTS_LINK_ON_PROMO_CODES_PAGE',
  PROMO_GO_TO_CART: 'CLICK_CART_LINK_ON_PROMO_CODES_PAGE',
  PROMO_GO_TO_USERS_REFERRALS: 'CLICK_REFERRALS_LINK_ON_PROMO_CODES_PAGE',
  PROMO_GO_TO_USERS_LOYALTY_POINTS: 'CLICK_LOYALTY_POINTS_LINK_ON_PROMO_CODES_PAGE',
  PROMO_CLICK_INFO_VOUCHER: 'CLICK_VIEW_VOUCHER_DETAIL_ON_PROMO_CODES_PAGE',
  PROMO_COPY_VOUCHER_CODE: 'CLICK_COPY_VOUCHER_DETAIL_ON_PROMO_CODES_PAGE',
  PROMO_CLICK_APPLY_VOUCHER: 'CLICK_APPLY_VOUCHER_DETAIL_ON_PROMO_CODES_PAGE',
  SCROLL_DOWN_FIRST_ON_PROMO_CODES_PAGE: 'SCROLL_DOWN_FIRST_ON_PROMO_CODES_PAGE',

  // page cart
  CLICK_APPLY_VOUCHER_ON_CART_PAGE: 'CLICK_APPLY_VOUCHER_ON_CART_PAGE',
  CLICK_VIEW_VOUCHER_CONDITION_ON_CART_PAGE: 'CLICK_VIEW_VOUCHER_CONDITION_ON_CART_PAGE',
  CLICK_SEARCH_VOUCHER_ON_CART_PAGE: 'CLICK_SEARCH_VOUCHER_ON_CART_PAGE',
  ON_CHANGE_SEARCH_VOUCHER_ON_CART_PAGE: 'ON_CHANGE_SEARCH_VOUCHER_ON_CART_PAGE',
  CLICK_OPEN_VOUCHER_POPUP_ON_CART_PAGE: 'CLICK_OPEN_VOUCHER_POPUP_ON_CART_PAGE',
  CLICK_GO_TO_CART_PAGE: 'CLICK_GO_TO_CART_PAGE',
  CLICK_COPY_VOUCHER_ON_CART_PAGE: 'CLICK_COPY_VOUCHER_ON_CART_PAGE',
  SCROLL_DOWN_FIRST_VOUCHER_POPUP_ON_CART_PAGE: 'SCROLL_DOWN_FIRST_VOUCHER_POPUP_ON_CART_PAGE',
});

export const ENUM_TRACKING_SOURCE = {
  QUICK_ORDER: 'quick-order',
  PRODUCT_LIST: 'product-list',
  PROMOTION: 'promotion',
  SELLER_HOME: 'seller-home',
  RECOMMENDATION: 'recommendation',
  RECOMMENDATION_TS: 'recommendation-ts',
  SAME_CATEGORY: 'same-category',
  WISHLIST: 'wishlist',
  VIEWED_LIST: 'viewed-list',
  HOME: 'home',
  PRODUCT_DETAIL: 'product-detail',
};

export const ENUM_COUNTDOWN_BAR_IMAGE_TYPE = {
  HALF: 'HALF',
  FULL: 'FULL',
};

export const ENUM_COUNTDOWN_BAR_DISPLAY_PAGE = {
  HOME: 'HOME',
  GUEST: 'GUEST',
};

const MAP_BRAND_NAME = {
  vn: 'thuocsi.vn',
  cam: 'BuyMed',
  kh: 'BuyMed',
  en: 'BuyMed',
  th: 'BuyMed',
};

export const BRAND_NAME = MAP_BRAND_NAME[`${ENV_COUNTRY}`] || MAP_BRAND_NAME.en;
export const BRAND_EMAIL_HELP = 'support@buymed.co.th';
export const BRAND_PHONE = HOTLINE;
export const BRAND_PHONE_DISPLAY = HOTLINE_TEXT;

export const ENUMS_ERROR_MSG_CODE = {
  STATUS_INVALID: 'Đã có lỗi xảy ra, xin vui lòng thử lại sau.',
  PROMOTION_NOT_FOUND: 'Mã khuyến mãi không tồn tại.',
  PROMOTION_INACTIVE: 'Mã khuyến mãi chưa được kích hoạt.',
  PROMOTION_TYPE_INVALID: 'Mã khuyến mãi có loại không hợp lệ.',
  LOYALTY_FAILED: 'Đã xảy ra lỗi khi đổi điểm.',
  LOYALTY_INVALID: 'Số điểm đổi phải nhỏ hơn 1000.',
  LOYALTY_NOT_FOUND: 'Điểm đổi không hợp lệ.',
  NOT_ENOUGH_POINTS: 'Bạn không có đủ điểm để đổi mã giảm giá này.',
  TYPE_INVALID: 'Đã có lỗi xảy ra, xin vui lòng thử lại sau.',
};

export const ENUMS_ERROR_ACC_CODE = {
  CUSTOMER_DELETED: 'CUSTOMER_DELETED',
  CUSTOMER_BLOCK: 'CUSTOMER_BLOCK',
  WRONG_PASSWORD: 'WRONG_PASSWORD', // Sai password
  NOT_FOUND: 'NOT_FOUND',
  CUSTOMER_DELETED_NO_ORDER_60_DAYS: 'CUSTOMER_DELETED_NO_ORDER_60_DAYS',
  CUSTOMER_DELETED_NO_ORDER_90_DAYS: 'CUSTOMER_DELETED_NO_ORDER_90_DAYS',
  INACTIVE_ACCOUNT: 'INACTIVE_ACCOUNT', // Tk bị khoá
  LOGIN_FAILED: 'LOGIN_FAILED', // sai thông tin username / tài khoản không tồn tại
  ACCOUNT_LOGIN_BLOCKED: 'ACCOUNT_LOGIN_BLOCKED', //  đăng nhập sai mật khẩu quá 5 lần, tài khoản đã bị khóa tạm thời
  '2FA_TOKEN_INVALID': '2FA_TOKEN_INVALID', // sai thông tin 2FA  (có thể bỏ qua do customer k bật chạy 2FA)
  NEED_VALIDATE_2FA: 'NEED_VALIDATE_2FA', // cần validate 2FA (có thể bỏ qua do customer k bật chạy 2FA)
  WRONG_TIMES_EXCEED_LIMIT: 'WRONG_TIMES_EXCEED_LIMIT', // Nhập sai OTP quá 5 lần (làm sẵn cho phần login OTP)
  NOT_FOUND_OTP: 'NOT_FOUND_OTP', // OTP không đúng (làm sẵn cho phần login OTP)
  EXPIRED_OTP: 'EXPIRED_OTP', // OTP đã hết hạn (làm sẵn cho phần login OTP)
  TOO_MANY_OTP_REQUESTS: 'TOO_MANY_OTP_REQUESTS', // request OTP quá nhiều lần (làm sẵn cho phần login OTP)
};

export const ENUMS_CHAT_SETTING_VALUE = {
  THUOCSI: 'THUOCSI',
  OFF: 'OFF',
  MESSENGER: 'MESSENGER',
};
export const UserType = {
  CUSTOMER: 'CUSTOMER',
  GUEST: 'GUEST',
  EMPLOYEE: 'EMPLOYEE',
};

export const ENUMS_FILTER_CATEGORY_TYPE = {
  EXTRA_CATEGORY: 'EXTRA_CATEGORY',
  CATEGORY: 'CATEGORY',
  MANUFACTURER: 'MANUFACTURER',
};

export const LANDING_PAGE_SECTIONS = {
  CAM: {
    FLASH_SALES: 'FLASH_SALES',
    DEALS_OF_THE_DAY: 'DEALS_OF_THE_DAY',
    PROMOTIONS: 'PROMOTIONS',
    FOR_YOU: 'FOR_YOU',
  },
  THAI: {
    FLASH_SALES: 'FLASH_SALES',
    DEALS_OF_THE_DAY: 'DEALS_OF_THE_DAY',
    PROMOTIONS: 'PROMOTIONS',
    FOR_YOU: 'FOR_YOU',
  },
};

export const POPUP_SHARING_ITEM = {
  FACEBOOK: 'FACEBOOK',
  ZALO: 'ZALO',
  TELEGRAM: 'TELEGRAM',
  LINKEDIN: 'LINKEDIN',
  TWITTER: 'TWITTER',
  VIBER: 'VIBER',
  LINE: 'LINE',
};

export const ENUM_CONDITION_TYPE = {
  SHARE: 'SHARE',
  DISCOVER: 'DISCOVER',
};

export const ENUMS_VOUCHER_ERROR_CODE = {
  NOT_FOUND: 'NOT_FOUND',
  INACTIVE: 'INACTIVE',
  NOT_START_YET: 'NOT_START_YET',
  EXPIRED: 'EXPIRED',
  NOT_ENOUGH_CONDITION: 'NOT_ENOUGH_CONDITION',
  OUT_OF_STOCK: 'OUT_OF_STOCK',
  CAN_NOT_USE: 'CAN_NOT_USE',
  OUT_OF_USE: 'OUT_OF_USE',
  NOT_SUPPORT_REGION: 'NOT_SUPPORT_REGION',
  NOT_SUPPORT_LEVEL: 'NOT_SUPPORT_LEVEL',
  NOT_SUPPORT_SCOPE: 'NOT_SUPPORT_SCOPE',
  NOT_ENOUGH_ORDER_VALUE: 'NOT_ENOUGH_ORDER_VALUE',
  NUMBER_OF_ORDER_EXCEED_LIMIT: 'NUMBER_OF_ORDER_EXCEED_LIMIT',
  NOT_ENOUGH_NUMBER_OF_ORDER: 'NOT_ENOUGH_NUMBER_OF_ORDER',
  INVALID_NUMBER_OF_ORDER: 'INVALID_NUMBER_OF_ORDER',
  NOT_ENOUGH_NO_ORDER_TIME: 'NOT_ENOUGH_NO_ORDER_TIME',
  INVALID_PRODUCT: 'INVALID_PRODUCT',
  NOT_ENOUGH_PRODUCT_QUANTITY: 'NOT_ENOUGH_PRODUCT_QUANTITY',
  NOT_ENOUGH_PRODUCT_AMOUNT: 'NOT_ENOUGH_PRODUCT_AMOUNT',
  VOUCHER_CODE_INVALID: 'VOUCHER_CODE_INVALID',
  CANNOT_APPLY_WITH_OTHERS: 'CANNOT_APPLY_WITH_OTHERS',
  INVALID_APP_VERSION: 'INVALID_APP_VERSION',
  NOT_ENOUGH_SKU_QUANTITY: 'NOT_ENOUGH_SKU_QUANTITY',
};
